module.exports = __webpack_public_path__ + "02_very_short_yellow.69d25a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_very_short_yellow.png
// module id = +Xgy
// module chunks = 0